import React from 'react';
import cn from 'classnames';
import { Title } from '../Elements';
import { getFieldValue } from './utils';
import classes from './OrderDetail.module.scss';
import SecurityField from 'components/SecurityField';
import { SECURITY_FIELDS } from 'helper/const';
import { useIsInternalUser } from 'helper/hooks';
import { getTypeByTargetColumn } from 'views/pages/ClientDetail/components/NewOrderModal/utils';

const OrderDetail = ({ className, values = [], companyId }) => {
  const { isInternalUser } = useIsInternalUser();
  return (
    <div className={cn(classes.wrapper, className)}>
      <Title>Order Details</Title>
      <div className={classes.innerContent}>
        {values.map((section, sIndex) => {
          return (
            <div className={classes.section} key={sIndex}>
              {section.fields.length > 0 &&
                section.fields.map((fieldGroup, fIndex) => (
                  <React.Fragment key={fIndex}>
                    <h4>{fieldGroup.category}</h4>
                    {fieldGroup.fields.length > 0 && (
                      <ul>
                        {fieldGroup.fields.map((sField, sIndex) => {
                          const shouldShowSecurityField =
                            SECURITY_FIELDS.includes(sField.target_column) &&
                            isInternalUser;
                          return (
                            <li key={sIndex}>
                              {!shouldShowSecurityField && (
                                <span>{sField.name}</span>
                              )}
                              <span>
                                {shouldShowSecurityField ? (
                                  <SecurityField
                                    fieldObj={{
                                      label: sField.name,
                                      value: sField.field_value,
                                      type_id: sField.subrecord_id,
                                      type: getTypeByTargetColumn(
                                        sField.target_column
                                      ),
                                      company_id: companyId,
                                      key: sField.target_column,
                                      otherSettings: {
                                        type: getTypeByTargetColumn(
                                          sField.target_column
                                        ),
                                        required: sField.is_required,
                                      },
                                    }}
                                    isReadOnly
                                  />
                                ) : (
                                  getFieldValue(sField)
                                )}
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </React.Fragment>
                ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderDetail;
